module.exports = __webpack_public_path__ + "img/list-books-exams.97b2c26e.png";